import HeatScoreTooltip from './HeatScoreTooltip';
import './HeatScoreTooltip.scss';

export default HeatScoreTooltip;